import { gql } from '@apollo/client'

export const AI_INSIGHT = gql`
  fragment AiInsight on AiInsight {
    id
    insightText
    insightType
    insightPriority
    metadata
  }
`
